import React from "react";

export const AISparkle = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6763 3.38477C17.4344 3.38477 21.2914 7.24192 21.2915 12C21.2915 16.7581 17.4344 20.6152 12.6763 20.6152C7.91819 20.6152 4.06104 16.7581 4.06104 12C4.06112 7.24197 7.91824 3.38485 12.6763 3.38477ZM13.104 7.31055C13.0177 7.01545 12.5995 7.01545 12.5132 7.31055L11.5366 10.6514C11.5072 10.7521 11.4283 10.8309 11.3276 10.8604L7.98682 11.8369C7.69172 11.9232 7.69172 12.3414 7.98682 12.4277L11.3276 13.4053C11.4283 13.4348 11.5072 13.5136 11.5366 13.6143L12.5132 16.9551C12.5996 17.2498 13.0175 17.2497 13.104 16.9551L14.0815 13.6143C14.111 13.5135 14.1898 13.4347 14.2905 13.4053L17.6313 12.4277C17.926 12.3412 17.9261 11.9233 17.6313 11.8369L14.2905 10.8604C14.1898 10.8309 14.111 10.752 14.0815 10.6514L13.104 7.31055Z"
        fill="url(#paint0_linear_3348_10948)"
      />
      <circle
        cx="12.6765"
        cy="12"
        r="11.5966"
        stroke="url(#paint1_linear_3348_10948)"
        strokeWidth="0.806897"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3348_10948"
          x1="4.06104"
          y1="12"
          x2="21.2915"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3348_10948"
          x1="12.6765"
          y1="0"
          x2="12.6765"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8F6FC" stopOpacity="0" />
          <stop offset="0.5" stopColor="#6B57C5" />
          <stop offset="1" stopColor="#F4F2FA" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
